import Func from "./Func";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  GetOptionBranchs(data, organizations) {
    let itemData = [];
    for (const i in organizations) {
      const orgID = organizations[i];
      if (data?.[orgID]) {
        itemData = [...itemData, data[orgID]];
      }
    }
    return itemData;
  },
  GetOptionDepartments(data, organizations) {
    let itemData = [];
    for (const i in organizations) {
      const orgID = organizations[i];
      if (data?.[orgID]) {
        itemData = [...itemData, data[orgID]];
      }
    }
    return itemData;
  },
  GetOptionDivisions(data, departments) {
    let itemData = [];
    for (const i in departments) {
      const deptID = departments[i];
      if (data?.[deptID]) {
        itemData = [...itemData, data[deptID]];
      }
    }
    return itemData;
  },
  GetCountryByPermission(data, userData) {
    const userSess = userData.user_sess;
    //console.log(userData);
    if (
      userSess.isExoGroup ||
      userSess.isAdmin ||
      userSess.userCanAccessAllCountries
    ) {
      return data;
    }
  },
  GetDataRelateCountry(data, filters, relateFields) {
    if (relateFields === undefined || relateFields === "") {
      relateFields = ["country", "work_country"];
    }
    let itemData = {};
    let country = [];
    let n = 0;
    for (const i in relateFields) {
      const relateField = relateFields[i];
      if (
        filters?.[relateField] &&
        filters?.[relateField] !== "" &&
        filters?.[relateField] != null
      ) {
        country.push(filters[relateField]);
      }
    }
    n = country.length;
    if (n === 0) {
      return data;
    }
    for (let i in country) {
      let country_code = country[i];
      if (country_code in data && country_code !== "") {
        itemData[country_code] = data[country_code];
      }
    }
    return itemData;
  },
  GetCountryExcludeEXOGroup(data) {
    const searchData = Func.SearchObject(data, "GROUP", "country_code");
    if (Object.keys(searchData).length > 0) {
      const index = Object.keys(searchData)[0];
      data.splice(index, 1);
    }
    return data;
  },
};
